import { StructureObjectDto } from '@/rtkApi/mddApiSliceGenerated'
import { SourceItem } from '@/rtkApi/mddApiSliceGeneratedV2'

import { findStructureForSourceItem } from './findStructureForSourceItem'
import { getAvailableStructures } from './getAvailableStructures'

export const getSourceObjectUuid = (
	row: SourceItem,
	structureObjects: StructureObjectDto[] | undefined,
): string | undefined => {
	if (!structureObjects?.length || !row) return
	if (row.objectType === 'SUB_SELECT') return

	const filteredStructureObjectsByType = getAvailableStructures({
		sourceItemRow: row,
		systemTables: structureObjects,
	})

	const matchingStructure = findStructureForSourceItem(
		row,
		filteredStructureObjectsByType,
	)

	return matchingStructure?.structureUuid
}
